const MONTHS_FULL = [
  "gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno",
  "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre",
];

const MONTHS_SHORT = [
  "gen", "feb", "mar", "apr", "mag", "giu",
  "lug", "ago", "set", "ott", "nov", "dic",
];

// Use UTC getters because we store dates extracted from filenames as UTC
// (the filename is timezone-less, so we preserve the literal value).
const partsUtc = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return null;
  return {
    day: d.getUTCDate(),
    month: d.getUTCMonth(),
    year: d.getUTCFullYear(),
    hour: d.getUTCHours(),
    minute: d.getUTCMinutes(),
    second: d.getUTCSeconds(),
  };
};

const pad = (n) => String(n).padStart(2, "0");

// Full Italian format. mode: "auto" (time only if non-zero), "always", "never"
export const formatPostDate = (iso, mode = "auto") => {
  const p = partsUtc(iso);
  if (!p) return "";
  const date = `${p.day} ${MONTHS_FULL[p.month]} ${p.year}`;
  const hasTime = p.hour !== 0 || p.minute !== 0 || p.second !== 0;
  if (mode === "never") return date;
  if (mode === "always" || (mode === "auto" && hasTime)) {
    return `${date} · ${pad(p.hour)}:${pad(p.minute)}`;
  }
  return date;
};

// Short version for cards / tight rows: "16 mar 2026 · 12:29"
export const formatPostDateShort = (iso) => {
  const p = partsUtc(iso);
  if (!p) return "";
  const date = `${p.day} ${MONTHS_SHORT[p.month]} ${p.year}`;
  const hasTime = p.hour !== 0 || p.minute !== 0 || p.second !== 0;
  if (hasTime) return `${date} · ${pad(p.hour)}:${pad(p.minute)}`;
  return date;
};

// Convert ISO UTC to value for <input type="datetime-local"> ("YYYY-MM-DDTHH:MM")
export const isoToDatetimeLocal = (iso) => {
  const p = partsUtc(iso);
  if (!p) return "";
  return `${p.year}-${pad(p.month + 1)}-${pad(p.day)}T${pad(p.hour)}:${pad(p.minute)}`;
};

// Convert "YYYY-MM-DDTHH:MM" (from input) to ISO UTC string — treated as UTC
// so what the user types is what we store (no timezone surprises).
export const datetimeLocalToIso = (v) => {
  if (!v) return null;
  const m = v.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/);
  if (!m) return null;
  const [, y, mo, d, h, mi, s] = m;
  const sec = s || "00";
  return `${y}-${mo}-${d}T${h}:${mi}:${sec}+00:00`;
};
